"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
function HamburguerIcon(_a) {
    var _b = _a.height, height = _b === void 0 ? "100px" : _b, _c = _a.color, color = _c === void 0 ? "currentColor" : _c, style = _a.style;
    return (react_1.default.createElement("svg", { height: height, style: style, x: "0px", y: "0px", viewBox: "0 0 100 100" },
        react_1.default.createElement("g", null,
            react_1.default.createElement("path", { fill: color, d: "M100,56.836H0V43.164h100V56.836z M100,17.085H0v13.672h100V17.085z M100,69.243H0v13.672h100V69.243z" }))));
}
exports.default = HamburguerIcon;
//# sourceMappingURL=index.js.map